import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import Benefit from './Benefit';

const Benefits: React.SFC<IntlProps> = ({ intl: { T, urlResolver } }) => (
  <MediaQuery>
    {({ md }) => (
      <div className="back-purple">
        <div className="container-grid">
          <div
            className={cx('flexbox p-y-5 p-x-3', {
              'flex-direction__column': !md,
            })}
          >
            <div
              className={cx(md ? 'flex-basis-0 flex-grow-1 m-r-3' : 'm-b-5')}
            >
              <Benefit
                title={T('Increase your rental income')}
                description={T(
                  'Thousands of high-quality tenants, with an above-average budget, searching on our platform everyday.',
                )}
              />
            </div>
            <div
              className={cx(md ? 'flex-basis-0 flex-grow-1 m-r-3' : 'm-b-5')}
            >
              <Benefit
                title={T('Save time with online bookings')}
                description={T(
                  'No need for in-person viewings or phone calls. Directly talk with potential tenants. Manage your rentals entirely online, via our platform.',
                )}
              />
            </div>
            <div className={cx(md && 'flex-basis-0 flex-grow-1')}>
              <Benefit
                title={T('Secure tenants months in advance')}
                description={T(
                  'On average our tenants book 2 months in advance. Our calendar enables you to secure bookings in advance.',
                )}
              />
            </div>
          </div>
        </div>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(Benefits);
